import { connect } from 'react-redux';

import { pushNotification } from 'src/modules/Notification';

import {
    selectIsNewMenuPublished,
    selectPublishNewMenuError,
    publishNewMenu,
    clearPublishNewMenu,
    selectRestaurantSlug
} from 'src/modules/Restaurant';

const mapDispatchToProps = {
    pushNotification,
    publishNewMenu,
    clearPublishNewMenu
};

const mapStateToProps = (state) => ({
    isPublished: selectIsNewMenuPublished(state),
    publishNewMenuError: selectPublishNewMenuError(state),
    slug: selectRestaurantSlug(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
